import calendar from './../util/calendar';

export default {
  init() {

  },
  finalize() {
    
    calendar.instantiate();
    calendar.populateCalendarMonth($('.tr-calendar-wrap').data('month-offset'));

    /* Was going to use Date.prototype.format but there is no documentation on this online and it seems to just be Chrome experimental for now */
    function formatDate(dateObject, form) {
      var date = '';

      for (var i = 0; i < form.length; i++) {
        const char = form.charAt(i);

        if (char == 'j') {
          const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
          date += days[dateObject.getDay()];
        } else if (char == 'd') {
          date += (dateObject.getDate() / 10).toString().replace('.', '');
        } else if (char == 'M') {
          const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          date += months[dateObject.getMonth()];
        } else if (char == 'm') {
          date += ((dateObject.getMonth() + 1) / 10).toString().replace('.', '');
        } else if (char == 'Y') {
          date += dateObject.getFullYear();
        } else {
          date += char;
        }
      }

      return date;
    }

    // Open/Close options dialogue
    $('.bi-options').on('click', function() {
      const $this = $(this);

      $('.bi-option-wrap').each(function() {
        if ($(this).get()[0] != $this.siblings('.bi-option-wrap').get()[0]) {
          $(this).removeClass('show');
        }
      });

      $(this).siblings('.bi-option-wrap').toggleClass('show');
    });

    // Delete a booking
    $('.bi-option[data-action="delete"]').on('click', function() {
      const id = $(this).data('id');

      // Open the popup
      $('.popup-delete-a-booking').addClass('show').data('id', id);
      $('.bi-option-wrap.show').removeClass('show');
    });

    // Close the popup
    $('.popup-delete-a-booking .dab-option-cancel').on('click', function() {
      $(this).parents('.popup-delete-a-booking').removeClass('show');
    });

    // Click delete on the popup
    $('.popup-delete-a-booking .dab-option-confirm').on('click', function() {
      const id = $('.popup-delete-a-booking').data('id');

      // Make the API call.
      $.ajax({
        url: '/wp-json/booking-manager/delete-booking',
        method: 'GET',
        data: {
          '_wpnonce': $('.wprestnonce').data('nonce'),
          'id': id,
        },
      }).done(function(e) {

        // Done. Redirect
        window.location.reload();

      });
    });

    // View a booking item (open popup)
    $('.bi-view').on('click', function() {
      const id = $(this).data('id');

      // Open popup
      $('.popup-view-a-booking').addClass('open');
      $('.popup-view-a-booking .popup-content').get()[0].scrollTo(0, 0)

      // Prevent outside scrolls
      $('body').addClass('overflow-hidden');

      // Open spinner
      $('.loading-spinner-wrap').addClass('show');

      // Send API request for data
      $.ajax({
        url: '/wp-json/booking-manager/get-booking-details',
        method: 'GET',
        data: {
          '_wpnonce': $('.wprestnonce').data('nonce'),
          'id': id,
        },
      }).done(function(e) {

        // Unpack the data
        $('#vab-order-number').html(`#${id}`);
        $('#vab-order-name').html(e.name);
        $('.popup-vab-number-visiting').html(e.number_visiting);

        if (e.ticket_types) {
          e.ticket_types.forEach((ticket_type) => {
            const $elementTicketItem = $(`
              <div class="popup-vab-ticket-item">
                <div class="popup-vab-ticket-item-name">${ticket_type.property}</div>
                <div class="popup-vab-ticket-item-amount">${ticket_type.value}</div>
              </div>
            `);

            $('.popup-vab-ticket-breakdown').append($elementTicketItem);
          });
        }

        $('.popup-vab-visit-date').html(e.visit_date);
        $('.popup-vab-visit-time').html(e.visit_time);
        $('.popup-vab-total-amount').html(e.total);

        if (e.additional_notes != '') {
          $('.popup-vab-additional-notes').removeClass('d-none');
          $('.popup-vab-additional-notes-text').html(e.additional_notes);
        }

        // Done loading
        $('.popup-view-a-booking').addClass('ready');
        
        // Close spinner
        $('.loading-spinner-wrap').removeClass('show');

      });
    });

    var lastEditingId = 0;

    // Edit booking item (open popup)
    $('.bi-option[data-action="edit"]').on('click', function() {
      const id = $(this).data('id');
      lastEditingId = id;

      // Open popup
      $('.popup-edit-booking').addClass('open');
      $('.popup-edit-booking .popup-content').get()[0].scrollTo(0, 0);
      
      // Prevent outside scrolls
      $('body').addClass('overflow-hidden');

      // Open spinner
      $('.loading-spinner-wrap').addClass('show');

      // Clear the data
      $('.popup-edit-booking #edit-order-number').html('');
      $('.popup-edit-booking #edit-order-name').html('');
      $('.popup-edit-booking .popup-number-visiting-btn').removeClass('active');
      $('.popup-edit-booking .popup-ticket-types-wrap .assign-box .box-quantifier').data('quantity', '0');
      $('.popup-edit-booking .popup-ticket-types-wrap .assign-box .box-quantifier-total').html('0');
      $('.popup-edit-booking .visit-time-changer').empty();
      $('.popup-error').addClass('d-none');
      // $('.popup-edit-booking .visit-date-changer option[data-created-after="1"]').remove();
      $('.popup-edit-booking').data('backup-visit-times', '');
      $('.popup-edit-booking').data('original-date-selected', '');
      $('.popup-edit-booking .additional-info-text').prop('value', '');
      $('.popup-edit-booking').data('changed', '[]');

      // Send API request for data
      $.ajax({
        url: '/wp-json/booking-manager/get-booking-details',
        method: 'GET',
        data: {
          '_wpnonce': $('.wprestnonce').data('nonce'),
          'id': id,
        },
      }).done(function(e) {

        // Unpack the data

        $('#edit-order-number').html(`#${id}`);
        $('#edit-order-name').html(e.name);

        $(`.popup-edit-booking .popup-number-visiting-btn[data-number="${e.number_visiting}"]`).addClass('active active-default');
        $('.popup-edit-booking').data('paid', e.total_amount);

        if (e.ticket_types) {
          e.ticket_types.forEach((ticket_type) => {
            const $box = $(`.popup-edit-booking .popup-ticket-types-wrap .assign-box[data-slug="${ticket_type.slug}"]`);
            $box.find('.box-quantifier').data('quantity', ticket_type.quantity);
            $box.find('.quantifier-total').html(ticket_type.quantity);
          });
        }

        const date = new Date(parseInt(e.visit_date_raw) * 1000);
        $('.popup-edit-booking').data('original-date-selected', parseInt(e.visit_date_raw));

        const dmY = ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();

        $('.tr-calendar-wrap').data('chosen-date', dmY);

        const currentDate = new Date();
        
        const year1 = currentDate.getFullYear();
        const year2 = date.getFullYear();

        const month1 = currentDate.getMonth() + 1;
        const month2 = date.getMonth() + 1;

        const monthOffset = ((year2 - year1) * 12) + (month2 - month1);

        $('.tr-calendar-wrap').data('month-offset', monthOffset);
        calendar.populateCalendarMonth(monthOffset);

        // const $existingDateOption = $(`.tr-calendar-wrap .tr-calendar-week-day[data-full-date="${dmY}"]`);
        // $existingDateOption.addClass('selected');
        // $('.popup-edit-booking .visit-date-changer-btn .visit-date').html(date.format('j d M, Y'));
        // const $dateOption = $(`<option value="${e.visit_date_raw}" selected>&gt; ${date.format('j d M, Y')}</option>`);
        // $('.popup-edit-booking .visit-date-changer').append($dateOption);

        // Get all available date options
        const $timeOption = $(`<option value="${e.visit_time_raw}" selected data-default="1" data-places-available="0">&gt; ${e.visit_time} [0]</option>`);
        $('.popup-edit-booking .visit-time-changer').append($timeOption);

        $('.additional-info-text').prop('value', e.additional_notes);

        // Get all available time options
        $.ajax({
          url: '/wp-json/booking/get-available-timeslots',
          method: 'GET',
          data: {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear(),
            includePlacesAvailable: true,
            includeFormatted: true,
            excludeBookingId: id,
          },
        }).done(function(availableTimeslots) {
          if (availableTimeslots) {
            availableTimeslots.forEach((availableTimeslot) => {
              if (availableTimeslot[0] != e.visit_time_raw) {
                const $availableTimeOption = $(`<option value="${availableTimeslot[0]}" data-places-available="${availableTimeslot[1]}">${availableTimeslot[2]} [${availableTimeslot[1]}]</option>`);
                $('.popup-edit-booking .visit-time-changer').append($availableTimeOption);
              } else {
                $(`.popup-edit-booking .visit-time-changer option[value="${e.visit_time_raw}"]`).data('places-available', availableTimeslot[1]);
                $(`.popup-edit-booking .visit-time-changer option[value="${e.visit_time_raw}"]`).attr('data-places-available', availableTimeslot[1]);
                $(`.popup-edit-booking .visit-time-changer option[value="${e.visit_time_raw}"]`).html(`&gt; ${e.visit_time} [${availableTimeslot[1]}]`);
              }
            });
          }
          
          // Done loading
          $('.popup-edit-booking').addClass('ready');

          // Close spinner
          $('.loading-spinner-wrap').removeClass('show');
        });

      });
    });

    function setChanged(property) {
      var changes = JSON.parse($('.popup-edit-booking').data('changed'));

      if (!changes.includes(property)) {
        changes.push(property);
      }

      $('.popup-edit-booking').data('changed', JSON.stringify(changes));
    }

    function checkEverythingIsOk() {

      $('#popup-edit-error-from-server').addClass('d-none');
      $('.popup-edit-booking #footer-editing-confirm').prop('disabled', true);

      // 1. Check the time not available message is not showing
      if ($('#popup-edit-error-time-not-available').hasClass('d-none')) {

        // 2. Check the tickets are delegated appropriately
        const numberVisiting = $('.popup-edit-booking .popup-number-visiting-btn.active').data('number');

        var ticketsSelected = 0;
        $('.popup-edit-booking .popup-ticket-types-wrap .assign-box').each(function() {
          ticketsSelected += ($(this).find('.box-quantifier').data('quantity') * $(this).data('default-quantity'));
        });

        if (numberVisiting == ticketsSelected) {

          // Everything should be ok
          $('.popup-edit-booking #footer-editing-confirm').prop('disabled', false);

        }

      } 
      
      setTicketsToAssign(); 

    }

    function checkVisitorQuantity() {
      const currentNumber = $('.popup-edit-booking .popup-number-visiting-btn.active').data('number');
      const selectedAvailable = $('.visit-time-changer option:selected').data('places-available');

      const $originalTimeslot = $('.popup-edit-booking .visit-time-changer option:selected[data-default="1"]');
      if ($originalTimeslot.length > 0) {
        // Original timeslot is chosen - if number visiting chosen is greater, fail if applicable, else, allow
        const $originalVisitors = $('.popup-edit-booking .popup-number-visiting-btn.active-default').data('number');

        if (currentNumber > $originalVisitors) {
          if (currentNumber > selectedAvailable) {
            $('#popup-edit-error-time-not-available').removeClass('d-none');
          } else {
            $('#popup-edit-error-time-not-available').addClass('d-none');
          }
        } else {
          $('#popup-edit-error-time-not-available').addClass('d-none');
        }
      } else {
        if (currentNumber > selectedAvailable) {
          $('#popup-edit-error-time-not-available').removeClass('d-none');
        } else {
          $('#popup-edit-error-time-not-available').addClass('d-none');
        }
      }
      
      checkEverythingIsOk();
    }

    // Edit popup - change number visiting
    $('.popup-edit-booking .popup-number-visiting-btn').on('click', function() {
      $('.popup-edit-booking .popup-number-visiting-btn.active').removeClass('active');
      $(this).addClass('active');
      checkVisitorQuantity();
    });

    // Edit popup - delegate tickets
    $('.popup-edit-booking .quantifier-less').on('click', function() {
      const quantity = parseInt($(this).parent().data('quantity'));

      if (quantity > 0) {
        $(this).parent().data('quantity', quantity - 1);
        $(this).siblings('.quantifier-total').html(quantity - 1);
        setChanged('ticket-types');
      }

      checkEverythingIsOk();
    });
    
    $('.popup-edit-booking .quantifier-more').on('click', function() {
      const ticketsToAssign = parseInt($('.prompt-remaining .prompt-remaining-quantity').html());
      const defaultQuantity = $(this).parents('.assign-box').data('default-quantity');
      const quantity = parseInt($(this).parent().data('quantity'));

      if (ticketsToAssign - defaultQuantity >= 0 || ticketsToAssign < 0) {
        $(this).parent().data('quantity', quantity + 1);
        $(this).siblings('.quantifier-total').html(quantity + 1);
        setChanged('ticket-types');
      }
      
      checkEverythingIsOk();
    });

    // Edit popup - change visit date
    $('.tr-calendar-wrap .tr-calendar-body .tr-calendar-week-day').on('click', function() {
      if ($(this).data('available')) {
        const $this_ = $(this);

        $('.tr-calendar-wrap .tr-calendar-body .tr-calendar-week-day.selected').each(function() {
          if ($(this).get()[0] != $this_.get()[0]) {
            $(this).removeClass('selected');
          }
        });

        $(this).addClass('selected');

        const fullDate = $(this).data('full-date');
        $('.tr-calendar-wrap').data('chosen-date', fullDate);
        $('input[name="tr_date_selection"]').val(fullDate);

        const dateSelectedFormatted = new Date(fullDate.split('-').reverse().join('-'));
  
        // Clear visit times
        $('.visit-time-changer').empty();
  
    // $('.popup-edit-booking .visit-date-changer').on('change', function() {

    //   const dateSelected = $(this).find('option:selected').prop('value');
    //   const dateSelectedFormatted = new Date($(this).find('option:selected').prop('value') * 1000);

    //   if (dateSelected == $('.popup-edit-booking').data('original-date-selected')) {
    //     // Revert backup
    //     $('.popup-edit-booking .visit-time-changer').html($('.popup-edit-booking').data('backup-visit-times'));
    //     checkVisitorQuantity();
    //   } else {
    //     // Backup visit times
    //     if ($('.popup-edit-booking').data('backup-visit-times') == '') {
    //       $('.popup-edit-booking').data('backup-visit-times', $('.popup-edit-booking .visit-time-changer').html());
    //     }

    //     // Clear visit times
    //     $('.popup-edit-booking .visit-time-changer').empty();

    //     console.log(dateSelectedFormatted);

        // Get times
        $.ajax({
          url: '/wp-json/booking/get-available-timeslots',
          method: 'GET',
          data: {
            day: dateSelectedFormatted.getDate(),
            month: dateSelectedFormatted.getMonth() + 1,
            year: dateSelectedFormatted.getFullYear(),
            includePlacesAvailable: true,
            includeFormatted: true,
            excludeBookingId: lastEditingId,
          },
        }).done(function(timeslots) {

          if (timeslots) {
            timeslots.forEach((timeslot) => {
              const $timeslotItem = $(`<option value="${timeslot[0]}" data-places-available="${timeslot[1]}">${timeslot[2]} [${timeslot[1]}]</option>`);
              $('.popup-edit-booking .visit-time-changer').append($timeslotItem);
            });

            setChanged('date');
            setChanged('time');
            checkVisitorQuantity();
          }

        });
      }

    });

    // Edit popup - Change timeslot
    $('.popup-edit-booking .visit-time-changer').on('change', function() {
      setChanged('time');
      checkVisitorQuantity();
    });

    // Edit popup - Undo changes
    $('.popup-edit-booking #footer-editing-undo').on('click', function() {
      // Close and reopen. JS triggers will be lost if we do a html backup
      $('.popup-edit-booking .popup-booking-close').trigger('click');
      $(`.bi-option[data-action="edit"][data-id="${lastEditingId}"]`).trigger('click');
      $('.popup-edit-booking').data('changed', '[]');
    });

    // Edit popup - change additional info
    $('.popup-edit-booking .additional-info-text').on('change', function() {
      setChanged('additional-info');
      checkVisitorQuantity();
    });

    function getAttendeesArray() {
      var pu_attendees = [];

      $('.popup-edit-booking .popup-ticket-types-wrap .assign-box').each(function() {
        const quantity = parseInt($(this).find('.box-quantifier').data('quantity'));

        if (quantity > 0) {
          pu_attendees.push({
            'ticket_type': $(this).data('slug'),
            'quantity': quantity,
          });
        }
      });

      return pu_attendees;
    }

    //// Ticket delegation
    // Set the 'tickets to assign' based on chosen tickets
    function setTicketsToAssign() {
      const quantityToAssign = $('.popup-number-visiting-btn.active').data('number');

      var quantityAssigned = 0;
      $('.assign-box').each(function() {
        quantityAssigned += $(this).find('.box-quantifier').data('quantity') * $(this).data('default-quantity');
      });

      if (quantityAssigned > quantityToAssign) {
        // Too many have been assigned. Just clear them all and restart.
        // quantityAssigned = 0;
        // $('.assign-box').each(function() {
        //   $(this).find('.box-quantifier').data('quantity', 0);
        //   $(this).find('.box-quantifier .quantifier-total').html('0');
        // });
      }
      
      const quantityRemaining = quantityToAssign - quantityAssigned;

      $('.prompt-remaining .prompt-remaining-quantity').html(quantityRemaining);

      // Plural/Single
      if (quantityRemaining == 1) {
        $('.prompt-remaining .prompt-remaining-ticket-single').removeClass('d-none');
        $('.prompt-remaining .prompt-remaining-ticket-plural').addClass('d-none');
      } else {
        $('.prompt-remaining .prompt-remaining-ticket-single').addClass('d-none');
        $('.prompt-remaining .prompt-remaining-ticket-plural').removeClass('d-none');
      }
    }

    // Edit popup - Confirm changes
    $('.popup-edit-booking #footer-editing-confirm').on('click', function() {

      $('#footer-confirming-confirm').prop('disabled', true);
      $('#footer-confirming-confirm-and-go').prop('disabled', true);

      // Just need to price up the difference
      const dateSelected = new Date($('.tr-calendar-wrap .tr-calendar-week-day.selected').data('full-date').split('-').reverse().join('-'));

      const pu_timeSlot = $('.popup-edit-booking .visit-time-changer option:selected').val();
      const pu_day = formatDate(dateSelected, 'd');
      const pu_month = formatDate(dateSelected, 'm');
      const pu_year = formatDate(dateSelected, 'Y');

      var pu_attendees = getAttendeesArray();

      $('.popup-edit-booking .content-confirmation #confirmation-loading').removeClass('d-none');
      $('.popup-edit-booking .content-confirmation #confirmation-data').addClass('d-none');
      $('.popup-edit-booking .content-editing').addClass('d-none');
      $('.popup-edit-booking .content-confirmation').removeClass('d-none');
      $('.popup-edit-booking .footer-editing').addClass('d-none');
      $('.popup-edit-booking .footer-confirming').removeClass('d-none');

      $.ajax({
        url: '/wp-json/booking/price-up',
        method: 'GET',
        data: {
          timeslot: pu_timeSlot,
          day: pu_day,
          month: pu_month,
          year: pu_year,
          attendees: btoa(JSON.stringify(pu_attendees)),
        },
      }).done(function(e) {
        if (e !== 'false') {
          $('#confirm-booking-value').html('&pound;' + parseFloat(e).toFixed(2));
          $('#confirm-booking-paid').html('&pound;' + parseFloat($('.popup-edit-booking').data('paid')).toFixed(2));
          $('#confirm-booking-difference').html('&pound;' + (parseFloat(e) - parseFloat($('.popup-edit-booking').data('paid'))).toFixed(2));
          
          $('.popup-edit-booking .content-confirmation #confirmation-loading').addClass('d-none');
          $('.popup-edit-booking .content-confirmation #confirmation-data').removeClass('d-none');

          $('#footer-confirming-confirm').prop('disabled', false);
          $('#footer-confirming-confirm-and-go').prop('disabled', false);
        } else {
          alert('An unexpected error has occurred. Please contact Creo support quoting message "price-up error"');
        }
      });
    });

    // Edit popup - confirm changes
    function editConfirmChanges(goToOrder = false) {
      var changes = [];
      
      $('#footer-confirming-confirm').prop('disabled', true);
      $('#footer-confirming-confirm-and-go').prop('disabled', true);

      const changesMade = JSON.parse($('.popup-edit-booking').data('changed'));

      if (changesMade.length > 0) {
        changesMade.forEach((change) => {
          if (change == 'ticket-types') {
            changes.push({
              property: 'tickets',
              value: getAttendeesArray(),
            });
          } else if (change == 'date') {
            const selectedDateStamp = new Date($('.tr-calendar-wrap .tr-calendar-week-day.selected').data('full-date').split('-').reverse().join('-'));
            const selectedDateFormatted = formatDate(selectedDateStamp, 'Ymd');

            changes.push({
              property: 'date',
              value: selectedDateFormatted,
            });
          } else if (change == 'time') {
            const selectedTime = $('.popup-edit-booking .visit-time-changer option:selected').prop('value');

            changes.push({
              property: 'time',
              value: selectedTime,
            });
          } else if (change == 'additional-info') {
            changes.push({
              property: 'additional_info',
              value: $('.popup-edit-booking .additional-info-text').prop('value'),
            });
          }
        });
      }

      // Send the changes to the server
      $.ajax({
        url: '/wp-json/booking-manager/edit-booking',
        method: 'post',
        data: {
          '_wpnonce': $('.wprestnonce').data('nonce'),
          changes: changes,
          id: lastEditingId,
        },
      }).done(function(e) {

        if (!e) {
          alert('An unexpected error has occurred. Please contact Creo support quoting message "edit-booking returned false"');
        } else {

          if (goToOrder) {
            window.location.replace(`/wp-admin/post.php?post=${lastEditingId}&action=edit`);
          } else {
            window.location.reload();
          }

        }

      })
    }

    $('.popup-edit-booking .footer-confirming #footer-confirming-confirm').on('click', function() {
      editConfirmChanges();
    });

    $('.popup-edit-booking .footer-confirming #footer-confirming-confirm-and-go').on('click', function() {
      editConfirmChanges(true);
    });

    // Close view popup
    $('.popup-view-a-booking .popup-booking-close').on('click', function() {
      $('.popup-view-a-booking').removeClass('ready');

      setTimeout(() => {
        $('.popup-vab-name').html('');
        $('.popup-vab-ticket-breakdown').empty();
        $('.popup-vab-additional-notes').addClass('d-none');

        $('.popup-view-a-booking').removeClass('open');

        // Enable outside scrolls
        $('body').removeClass('overflow-hidden');
      }, 250);
    });

    // Close edit popup
    $('.popup-edit-booking .popup-booking-close').on('click', function() {
      $('.popup-edit-booking').removeClass('ready');

      setTimeout(() => {
        $('.popup-edit-booking').removeClass('open');
        $('.popup-edit-booking .content-editing').removeClass('d-none');
        $('.popup-edit-booking .content-confirmation').addClass('d-none');
        $('.popup-edit-booking .footer-editing').removeClass('d-none');
        $('.popup-edit-booking .footer-confirming').addClass('d-none');

        // Enable outside scrolls
        $('body').removeClass('overflow-hidden');
      }, 250);
    });

    $(window).on('click', function(e) {
      // Close booking item option dropdown
      if (!$(e.target).hasClass('bi-options') && $(e.target).parents('.bi-options').length == 0 && !$(e.target).hasClass('.bi-option-wrap') && $(e.target).parents('.bi-option-wrap').length == 0) {
        $('.bi-option-wrap').removeClass('show');
      }

      // Close delete a booking popup
      if ($(e.target).hasClass('popup-delete-a-booking')) {
        $('.popup-delete-a-booking').removeClass('show');
      }
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateBookingManagerBookings.js